import * as VerticalConstants from '../actions/Vertical/VerticalConstants';
import { VerticalState } from '../actions/Vertical/VerticalTypes';

export default (state = VerticalConstants.DEFAULT_STATE, action: any): VerticalState => {
  switch (action.type) {
    case VerticalConstants.VerticalAction.FETCH_VERTICAL:
      return { ...state, verticals: action.payload.VerticalList };
    default:
      return state;
  }
};
